import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataHandler } from 'C4';
import img from '../../assets/images/bg.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  loadBgImage() {
    if (window.location.href.includes('/training/chapter/2435')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter1_bg.jpg',
      });
    } else if (window.location.href.includes('/training/chapter/2436')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter2_bg.jpg',
      });
    } else if (window.location.href.includes('/training/chapter/2437')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter3_bg.jpg',
      });
    } else if (window.location.href.includes('/training/chapter/2438')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/c5_background.jpg',
      });
    } else if (window.location.href.includes('/training/chapter/2676')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/c4_background.jpg',
      });
    } else if (window.location.href.includes('/ret/chapter/2435')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter1_bg.jpg',
      });
    } else if (window.location.href.includes('/ret/chapter/2436')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter2_bg.jpg',
      });
    } else if (window.location.href.includes('/ret/chapter/2437')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/chapter3_bg.jpg',
      });
    } else if (window.location.href.includes('/ret/chapter/2438')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/c5_background.jpg',
      });
    } else if (window.location.href.includes('/ret/chapter/2676')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/c4_background.jpg',
      });
    } else if (window.location.href.includes('/training')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/learn_bg.jpg',
      });
    } else if (window.location.href.includes('/retain')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/retain_bg.jpg',
      });
    } else if (window.location.href.includes('/promote')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/promote_bg.jpg',
      });
    } else if (window.location.href.includes('/sell')) {
      this.setState({
        image: 'https://front.travpromobile.com/743/sell2_bg.jpg',
      });
    } else {
      this.setState({
        image: img,
      });
    }
  }

  render() {
    const { image } = this.state;
    const { blur, darken } = this.props;

    return (
      <div className="bgImage">
        {image && (
          <div
            style={{ backgroundImage: `url("${image}")` }}
            className={`backgroundImage ${blur && 'blur'} ${darken &&
              'darken'}`}
          />
        )}
        {window.location.href.includes('/promote') && <div className="imageCredits"><FontAwesomeIcon icon={['fab', 'instagram']}/> wingchunjourn</div>}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
